import { Quill } from 'react-quill'

let BlockEmbed = Quill.import('blots/block/embed');

class HorizontalRule extends BlockEmbed {}
HorizontalRule.blotName = 'hr';
HorizontalRule.tagName = 'hr';

export default HorizontalRule;


// WEBPACK FOOTER //
// ./src/vendor/hr.js